export type SearchCategoryName = {
  category: string;
  subCategory?: string;
  categoryType?: 'M' | 'F';
  subCategoryType?: 'M' | 'F';
  subCategoryEnPart?: string;
};

const getCategoryBySlug = (
  search: TCategorySelection,
  groups: Array<TCategory>
): SearchCategoryName => {
  try {
    const category = groups.find(
      (el: TCategory) => el.slug === search.category
    );
    const fakeCategory = {
      ...category,
      parts: Object.values(category?.parts).reduce(
        (acc, arr) => [...acc, ...arr],
        []
      ),
    };

    const subCategory = search?.subCategory
      ? fakeCategory?.parts.find((el: TPart) => el.slug === search.subCategory)
      : null;

    return {
      category: category?.name || '',
      categoryType: category?.gender || 'M',
      ...(search?.subCategory && {
        subCategory: subCategory?.name || '',
        subCategoryType: subCategory?.gender || 'M',
        subCategoryEnPart: subCategory?.part_en || '',
      }),
    };
  } catch (e) {
    return {
      category: '',
      categoryType: 'M',
      subCategory: '',
      subCategoryType: 'M',
      subCategoryEnPart: ''
    };
  }
};

export default getCategoryBySlug;
